import type { RouteObject } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import PaymentDetails from '@/pages/PaymentDetails';
import Home from '@/pages/home/invoice-page';

const routes: RouteObject[] = [
  {
    path: '/invoice/:invoiceId',
    element: <Home />,
  },
  {
    path: '/invoice/:invoiceId/payment-details',
    element: <PaymentDetails />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
